import DynamicIcon, { IconName } from '@/components/DynamicIcon'

const ImpactIcon: React.FC<{ icon: string; content: string }> = ({ icon, content }) => {
  return (
    <div className="flex w-full items-center gap-1.5 self-stretch sm:gap-3">
      <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-accent-foreground p-1 xl:size-16">
        <DynamicIcon name={icon as IconName} className="size-7 text-accent xl:size-8" />
      </div>
      <p className="text-left font-body text-sm leading-normal font-medium text-foreground sm:text-base xl:text-xl">
        {content}
      </p>
    </div>
  )
}

export default ImpactIcon
